<template>
    <div class="lazy-background__container">
        <div
            v-if="imageObject != null"
            v-lazy:background-image="imageObject"
            :data-webp="imageObject.webP"
            :name="imageObject.altText"
            class="lazy-background lazy-background--loading"
        ></div>
        <div
            v-if="imageObject != null"
            v-lazy:background-image="imageObject"
            :data-webp="imageObject.webP"
            :name="imageObject.altText"
            class="lazy-background"
        ></div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: {
        image: {
            type: Object,
            default() {
                return {};
            }
        },
        imageId: {
            type: Number,
            default() {
                return -1;
            }
        }
    },

    data() {
        return {
            imageObject: null,
            cropName: null,
            width: null
        };
    },

    mounted() {
        if (this.image != null && Object.keys(this.image).length > 0) {
            // we hebben een afbeelding
            this.imageObject = this.image;
        } else if (this.imageId > 0) {
            if (window.innerWidth <= 800) {
                this.cropName = 'CinemaPortrait';
                this.width = '345';
            } else if (window.innerWidth <= 1200) {
                this.cropName = 'FullFrame';
                this.width = '1143';
            } else {
                this.cropName = 'FullFrame';
                this.width = '1600';
            }

            const imageId = this.imageId;
            const url = `/api/imageapi/GetImage?imageId=${imageId}&cropName=${
                this.cropName
            }&width=${this.width}`;
            axios({
                method: 'get',
                url: url
            }).then(response => {
                if (response.data !== null) {
                    this.imageObject = JSON.parse(response.data);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.lazy-background__container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
}

.lazy-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s ease;
    background-size: cover;
    background-position: center;
}

.lazy-background--loading {
    filter: blur(16px);
}

.lazy-background--loading,
.lazy-background[lazy='loaded'] {
    opacity: 1;
}

.lazy-background--loading[lazy='loaded'] {
    opacity: 0;
}
</style>
